import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<i class=\"material-icons\">file_download</i> Download As CSV",{ moduleName: "sh-www/components/sh-download-as-csv.hbs" })